// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Op","buttonPrev":"e_Pp","buttonNext":"e_Qp","hidden":"e_Rp","iconPrev":"e_Sp","iconNext":"e_Tp","scrollView":"e_Up","card":"e_Vp","scroller":"e_Wp"};